import clsx from 'clsx'
import React, { FC } from 'react'

import styles from './Title.module.scss'

interface TitleTextProps {
  title: string
  type: 'h1' | 'h2' | 'h3' | 'h4'
}

const TitleText: FC<TitleTextProps> = ({ title, type }) => {
  if (type === 'h1') {
    return (
      <h1>{title}</h1>
    )
  }
  if (type === 'h2') {
    return (
      <h2>{title}</h2>
    )
  }
  if (type === 'h3') {
    return (
      <h3 style={{ maxWidth: '750px' }}>{title}</h3>
    )
  }
  return (
    <h4>{title}</h4>
  )
}

interface TitleProps extends TitleTextProps {
  bold?: boolean
  className?: string
  subtitle?: string
}
export const Title: FC<TitleProps> = ({ bold, className, subtitle, type, ...props }) => (
  <div className={clsx(className, styles.titleWrapper, bold && styles.bold)}>
    <TitleText type={type} {...props} />
    {subtitle && (type === 'h1' || type === 'h2') && (
      <p className={styles.subtitle}>{subtitle}</p>
    )}
  </div>
)
